import { render, staticRenderFns } from "./TasksDetail.vue?vue&type=template&id=122175cd"
import script from "./TasksDetail.vue?vue&type=script&lang=js"
export * from "./TasksDetail.vue?vue&type=script&lang=js"
import style0 from "./TasksDetail.vue?vue&type=style&index=0&id=122175cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports